import { render, staticRenderFns } from "./largeScreenDisplay.vue?vue&type=template&id=49f1d4ca&scoped=true"
import script from "./largeScreenDisplay.vue?vue&type=script&lang=js"
export * from "./largeScreenDisplay.vue?vue&type=script&lang=js"
import style0 from "./largeScreenDisplay.vue?vue&type=style&index=0&id=49f1d4ca&prod&lang=less&scoped=true"
import style1 from "./largeScreenDisplay.vue?vue&type=style&index=1&id=49f1d4ca&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f1d4ca",
  null
  
)

export default component.exports